<template>
  <SkeletonLoader>
    <div class="convos-skeleton">
      <div class="convos-skeleton__sidebar">
        <div class="convos-skeleton__search">
          <div class="sk-rect" style="height: 36px; width: 100%;"></div>
        </div>
        <div v-for="i in 6" :key="'patient-' + i" class="sk-row">
          <div class="sk-circle sk-circle--lg"></div>
          <div class="sk-col">
            <div class="sk-line" :style="{ width: nameWidths[i] }"></div>
            <div class="sk-line sk-line--sm" :style="{ width: msgWidths[i] }"></div>
          </div>
          <div class="sk-line sk-line--sm" style="width: 40px; flex-shrink: 0;"></div>
        </div>
      </div>
      <div class="convos-skeleton__main">
        <div class="convos-skeleton__header sk-row">
          <div class="sk-circle sk-circle--md"></div>
          <div class="sk-col">
            <div class="sk-line" style="width: 35%;"></div>
            <div class="sk-line sk-line--sm" style="width: 20%;"></div>
          </div>
        </div>
        <div class="convos-skeleton__messages">
          <div v-for="i in 5" :key="'msg-' + i" class="convos-skeleton__msg" :class="{ 'convos-skeleton__msg--right': i % 2 === 0 }">
            <div class="sk-rect" :style="{ width: bubbleWidths[i][0], height: bubbleWidths[i][1] }"></div>
          </div>
        </div>
        <div class="convos-skeleton__footer">
          <div class="sk-rect" style="height: 42px; width: 100%; border-radius: 10px;"></div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue';

export default {
  name: 'ConversationsSkeleton',
  components: { SkeletonLoader },
  data() {
    return {
      nameWidths: { 1: '55%', 2: '70%', 3: '45%', 4: '60%', 5: '50%', 6: '65%' },
      msgWidths: { 1: '80%', 2: '60%', 3: '75%', 4: '55%', 5: '70%', 6: '50%' },
      bubbleWidths: {
        1: ['45%', '40px'],
        2: ['35%', '48px'],
        3: ['55%', '36px'],
        4: ['40%', '44px'],
        5: ['50%', '38px'],
      }
    };
  }
}
</script>

<style lang="scss" scoped>
.convos-skeleton {
  display: flex;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
  height: calc(100vh - 220px);
  min-height: 400px;
}

.convos-skeleton__sidebar {
  width: 300px;
  border-right: 1px solid #e2e8f0;
  background: #f8fafc;
  flex-shrink: 0;
}

.convos-skeleton__search {
  padding: 8px 12px 12px;
}

.convos-skeleton__main {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.convos-skeleton__header {
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.convos-skeleton__messages {
  flex: 1;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.convos-skeleton__msg {
  display: flex;
  &--right { justify-content: flex-end; }
}

.convos-skeleton__footer {
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

@media (max-width: 768px) {
  .convos-skeleton__sidebar { display: none; }
}
</style>
